import * as React from 'react';
import classnames from 'classnames';
import classes from './index.module.scss.js';

class ItemSkeleton extends React.PureComponent {
    render() {
        const { flavor } = this.props;
        return (React.createElement("div", { className: classnames(classes.container, classes[flavor]) },
            React.createElement("div", { className: classes.skeleton })));
    }
}

export { ItemSkeleton as default };
//# sourceMappingURL=index.js.map
